import React from 'react'
import { string, number } from 'prop-types'

import { Card, CardBlock } from 'components/qstrap'
import Typography from 'components/atoms/Typography'

const WhyKITItem = ({ content, no }) => (
  <div className="why-kit-item">
    <Card className="why-kit-item__card">
      <CardBlock>
        <div className="why-kit-item__content">
          <div className="why-kit-item__no">
            <span>{no}</span>
          </div>
          <div className="why-kit-item__text">
            <Typography component="p" variant="body">
              { content }
            </Typography>
          </div>
        </div>
      </CardBlock>
    </Card>
  </div>
)

WhyKITItem.propTypes = {
  content: string,
  no: number,
}

export default WhyKITItem
